import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { registerSw } from "@/lib/push";
import { HelmetProvider } from "react-helmet-async";

window.addEventListener("load", registerSw);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const rootEl = document.getElementById("root");
const app = (
  <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </HelmetProvider>
  </React.StrictMode>
);
/* HTML pré-rendu (react-snap) → hydratation ; pré-rendu statique (fallback sans Chrome) ou vide → rendu client. */
if (rootEl.hasChildNodes()) {
  /* Les balises SEO pré-rendues sont recréées par Helmet : on retire les copies statiques pour éviter les doublons. */
  document.querySelectorAll('head > meta[name="description"], head > meta[name="robots"], head > meta[property^="og:"], head > meta[name^="twitter:"], head > link[rel="canonical"], head > link[rel="alternate"][hreflang], script[type="application/ld+json"]:not([data-keep]), head > title').forEach((el) => el.remove());
}
if (rootEl.hasChildNodes() && rootEl.dataset.prerender !== "static") {
  /* Les parties dynamiques (bandeau cookies, langue mémorisée) peuvent différer du HTML pré-rendu : React re-rend alors côté client, sans bruit console. */
  ReactDOM.hydrateRoot(rootEl, app, { onRecoverableError: (err) => { if (!/#4(18|23|25)|hydrat/i.test(String(err))) console.error(err); } });
} else {
  ReactDOM.createRoot(rootEl).render(app);
}
